const s = {
  auth: {
    all: ["auth"]
  },
  users: {
    all: ["users"],
    currentUser: () => [...s.users.all, "current-user"],
    loginStreak: () => [...s.users.all, "login-streak"],
    list: () => [...s.users.all, "list"],
    searchStudents: (l) => [...s.users.all, "search-students", l],
    detail: (l) => [...s.users.all, "detail", l],
    userCourses: (l) => [...s.users.all, "user-courses", l]
  },
  courses: {
    all: ["courses"],
    list: () => [...s.courses.all, "list"],
    available: (l) => [...s.courses.all, "available", l],
    detail: (l) => [...s.courses.all, "detail", l],
    completion: (l) => [...s.courses.all, "completion", l],
    lessons: (l) => [...s.courses.all, "lessons", l],
    lessonsProgress: (l) => [...s.courses.all, "lessons-progress", l],
    objectives: (l) => [...s.courses.all, "objectives", l],
    reviewNotes: (l) => [...s.courses.all, "review-notes", l],
    instructors: (l) => [...s.courses.all, "instructors", l],
    reviews: (l) => [...s.courses.all, "reviews", l]
  },
  lessons: {
    all: ["lessons"],
    list: () => [...s.lessons.all, "list"],
    detail: (l) => [...s.lessons.all, "detail", l],
    objectives: (l) => [...s.lessons.all, "objectives", l]
  },
  objectives: {
    all: ["objectives"],
    list: () => [...s.objectives.all, "list"],
    detail: (l) => [...s.objectives.all, "detail", l]
  },
  mediaRatings: {
    all: ["media-ratings"],
    userRating: (l) => [...s.mediaRatings.all, l]
  },
  degrees: {
    all: ["degrees"],
    list: () => [...s.degrees.all, "list"],
    detail: (l) => [...s.degrees.all, "detail", l],
    courses: (l) => [...s.degrees.all, "courses", l],
    userCourses: (l, e) => [...s.degrees.all, "user-courses", l, e]
  },
  schedule: {
    all: ["schedule"],
    list: () => [...s.schedule.all, "list"],
    detail: (l) => [...s.schedule.all, "detail", l]
  },
  availabilitySlots: {
    all: ["availability-slots"],
    list: (l) => [...s.availabilitySlots.all, "list", l],
    day: (l) => [...s.availabilitySlots.all, "day", l]
  },
  scheduledCalls: {
    all: ["scheduled-calls"],
    list: (l) => [...s.scheduledCalls.all, "list", l],
    today: () => [...s.scheduledCalls.all, "today"]
  },
  courseHearings: {
    all: ["course-hearings"],
    list: (l) => [...s.courseHearings.all, "list", l],
    detail: (l) => [...s.courseHearings.all, "detail", l]
  },
  chat: {
    all: ["chat"],
    list: () => [...s.chat.all, "list"],
    detail: (l) => [...s.chat.all, "detail", l]
  },
  notifications: {
    all: ["notifications"],
    list: () => [...s.notifications.all, "list"],
    detail: (l) => [...s.notifications.all, "detail", l]
  },
  projects: {
    all: ["projects"],
    list: () => [...s.projects.all, "list"],
    detail: (l) => [...s.projects.all, "detail", l]
  },
  quizzes: {
    all: ["quizzes"],
    list: (l) => [...s.quizzes.all, "list", l],
    detail: (l) => [...s.quizzes.all, "detail", l]
  },
  newlaneTutorials: {
    all: ["newlane-tutorials"],
    list: () => [...s.newlaneTutorials.all, "list"],
    detail: (l) => [...s.newlaneTutorials.all, "detail", l]
  },
  announcements: {
    all: ["announcements"],
    list: () => ["announcements", "list"],
    detail: (l) => ["announcements", "detail", l]
  },
  courseCategories: {
    all: ["courseCategories"],
    list: () => ["courseCategories", "list"]
  },
  coursePlan: {
    all: ["coursePlan"],
    saved: () => [...s.coursePlan.all, "saved"],
    suggestion: (l) => [...s.coursePlan.all, "suggestion", l ?? "none"],
    options: (l) => [...s.coursePlan.all, "options", l ?? "all"]
  },
  billing: {
    all: ["billing"],
    info: () => ["billing", "info"]
  },
  subscription: {
    all: ["subscription"]
  },
  userProjects: {
    all: ["user-projects"],
    list: (l) => ["user-projects", "list", l],
    submissions: (l, e) => ["user-projects", "submissions", l, e]
  },
  userNotes: {
    all: ["user-notes"],
    forObjective: (l) => ["user-notes", "objective", l],
    forLesson: (l) => ["user-notes", "lesson", l],
    forCourse: (l) => ["user-notes", "course", l]
  },
  transcripts: {
    all: ["transcripts"],
    evaluation: () => [...s.transcripts.all, "evaluation"],
    list: () => [...s.transcripts.all, "list"],
    evaluations: (l) => [...s.transcripts.all, "evaluations", l],
    evaluationDetail: (l) => [...s.transcripts.all, "evaluation-detail", l]
  }
};
export {
  s as teachurKeys
};
